export default {
	export_text_1: 'Export to file',
	export_text_2: 'File type',
	export_text_3: 'Group',
	export_text_4: 'Separator (default semicolon)',
	export_text_5: 'Export',
};